module.exports = __webpack_public_path__ + "static/media/NewLoginImg.f6f8d3b2.jpg";